import { mapDTO } from '@twistezo/ts-dto-mapper'
import { omit } from 'lodash'

import { Ability } from 'providers/casl'
import { fieldsToOmit } from 'providers/tanstack-query/utils'
import { floatPercentToDTO } from 'utils/number'
import { Schema } from '../../../schema'
import { Variables } from './types'

export const toDTO = (from: Schema, ability: Ability): Variables =>
  mapDTO<Schema, Variables>({ from }).transform((data: Schema): Variables => {
    const {
      allowActivitiesData,
      auctionDelay,
      connectionSpeed,
      gdprTcfEnabled,
      gdprTcfTimeout,
      gppControlUsNat,
      gppControlUsStates,
      gppEnabled,
      gppTimeout,
      prebidCustomConfig,
      prebidTimeout,
      prebidVariableName,
      s2sTimeoutMultiplier,
      usPrivacyCcpaEnabled,
      usPrivacyCcpaTimeout,
      videoPlayer,
      workspaceId,
    } = data

    const constatntFields: Omit<Variables, 'prebidVariableName'> = {
      allowActivitiesData: allowActivitiesData.length > 0 ? allowActivitiesData : null,
      auctionDelay,
      disablePrebidStackForUsersWithPoorInternetEnabled: Boolean(
        connectionSpeed.disablePrebidStack,
      ),
      gdprTcfEnabled,
      gdprTcfTimeout,
      gppControlUsNat,
      gppControlUsStates,
      gppEnabled,
      gppTimeout,
      maximumRttToEnablePrebidStack: connectionSpeed.maxRtt,
      prebidCustomConfig: JSON.parse(prebidCustomConfig),
      prebidTimeout,
      s2sTimeoutMultiplier: floatPercentToDTO(s2sTimeoutMultiplier),
      usPrivacyCcpaEnabled,
      usPrivacyCcpaTimeout,
      videoPlayer,
      workspaceId,
    }

    const variableFields: Pick<Variables, 'prebidVariableName'> = {
      prebidVariableName: prebidVariableName || null,
    }

    return {
      ...constatntFields,
      ...omit(
        variableFields,
        fieldsToOmit<Variables>({
          prebidVariableName: ability.cannot('update', 'GlobalSetupField-prebidVariableName'),
        }),
      ),
    }
  })
